import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class MfaGuard  {
	constructor(
		private auth: AuthenticationService,
		private router: Router
	) {
	}

	canActivate(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		route: ActivatedRouteSnapshot,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.auth.decodedToken$.pipe(
			take(1),
			map(({rol}) => {
				const roles = [].concat(rol);
				if (!roles.includes('mfa')) {
					return true;
				}
				return this.router.createUrlTree(['/', 'identity', 'mfa-selection']);
			})
		);
	}

}

